import styled from 'styled-components';
import { styles } from '../../../../../consts';

const { white, fontMontserrat, paymentDescription } = styles;

export const Container = styled.div`
  width: 100%;
  display: inline-flex;
  cursor: pointer;
  box-sizing: border-box;
  background-color: ${white};
  box-shadow: 0 0.1625rem 0.125rem 0 rgba(0, 0, 0, 0.22);
  border-radius: 0.1875rem;
  border-width: 0;
  margin: 0.3rem 0 0.3rem 0;

  @media (max-width: 768px) {
    margin: 0.2rem 0 0.2rem 0;
  }

  .saved-instrument-input-card-data__details {
    margin-top: 0.725rem;
  }
`;

export const InlineDiv = styled.div`
  display: inline-block;
  margin: 0.625rem 0.125rem 0.625rem 0;
`;

export const ImageWrapper = styled(InlineDiv)`
  width: 4.5rem;
  height: 1.145rem;
  padding: 0.7rem 0 0.7rem 0.5rem;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 2.625rem;
  }

  @media (max-width: 992px) {
    height: 1.0875rem;
    width: 4rem;

    img {
      width: 2.5rem;
    }
  }
`;

export const ButtonTitle = styled.div`
  font-family: ${fontMontserrat};
  font-weight: 400;
  font-size: 0.75rem;
`;

export const ButtonDescription = styled.div`
  margin-top: 0.325rem;
  font-family: ${fontMontserrat};
  font-weight: 400;
  font-size: 0.625rem;
  color: ${paymentDescription};
`;
